import React from 'react';

interface ArtistCoverProps {
  className?: string;
}
export const ArtistCover = (props: ArtistCoverProps) => {
  return (
    <svg
      className={props.className}
      width="120"
      height="106"
      viewBox="0 0 120 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M17.0244 12.0986C43.8525 -4.92188 81.2079 -2.1241 106.363 18.8291C127.716 36.6149 120.08 87.1053 97.8441 98.8076C78.2301 109.13 38.2075 106.935 19.4896 89.2964C18.4059 88.2753 19.427 85.7664 18.8505 84.216C17.6886 81.0917 16.1551 78.1614 14.3767 75.5479C12.8189 73.2586 9.80211 72.4777 8.94201 69.6549L5.95948 68.0296C-0.0394368 48.3413 -3.70751 26.4542 13.868 16.3332L17.0244 12.0986Z"
        stroke="#727476"
      />
    </svg>
  );
};
